import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// const ProtectedRoute = ({ children }) => {
//   return children;
// };

// export default ProtectedRoute;

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <p>Loading...</p>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
